// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rig-list-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
}
.rig-list-panel .panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.rig-list-panel .panel-header h3 {
  margin: 0;
}
.rig-list-panel .responsive-table {
  flex: 1;
  min-height: 0;
  max-height: calc(100vh - 220px);
  max-height: calc(100dvh - 220px);
  overflow: auto;
}
.rig-list-panel .rigs-table {
  width: 100%;
  cursor: pointer;
}
.rig-list-panel .rigs-table th.mat-mdc-header-cell {
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #0066b2;
  color: #fff;
}
.rig-list-panel .rigs-table td.mat-mdc-cell,
.rig-list-panel .rigs-table th.mat-mdc-header-cell {
  padding: 0 12px;
}
.rig-list-panel .rigs-table .selected-row td.mat-mdc-cell {
  background-color: var(--p-primary-100, #e3f2fd);
  font-weight: 500;
}
.rig-list-panel .rigs-table tr.mat-mdc-row:hover {
  background-color: var(--p-surface-100, #f5f5f5);
}
.rig-list-panel .rigs-table tr.mat-mdc-row.selected-row:hover td.mat-mdc-cell {
  background-color: var(--p-primary-100, #e3f2fd);
}
.rig-list-panel .empty-message {
  color: var(--p-text-muted-color, #888);
  padding: 16px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rigs/rig-list/rig-list.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACE,SAAA;AADN;AAKE;EACE,OAAA;EACA,aAAA;EACA,+BAAA;EACA,gCAAA;EACA,cAAA;AAHJ;AAME;EACE,WAAA;EACA,eAAA;AAJJ;AAMI;EACE,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,yBCnCQ;EDoCR,WAAA;AAJN;AAOI;;EAEE,eAAA;AALN;AASM;EACE,+CAAA;EACA,gBAAA;AAPR;AAWI;EACE,+CAAA;AATN;AAYI;EACE,+CAAA;AAVN;AAcE;EACE,sCAAA;EACA,eAAA;AAZJ","sourcesContent":["@use '../../../../styles/colors' as colors;\n\n.rig-list-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 1rem;\n\n  .panel-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n\n    h3 {\n      margin: 0;\n    }\n  }\n\n  .responsive-table {\n    flex: 1;\n    min-height: 0;\n    max-height: calc(100vh - 220px);\n    max-height: calc(100dvh - 220px);\n    overflow: auto;\n  }\n\n  .rigs-table {\n    width: 100%;\n    cursor: pointer;\n\n    th.mat-mdc-header-cell {\n      font-weight: 600;\n      position: sticky;\n      top: 0;\n      z-index: 2;\n      background-color: colors.$medium-blue;\n      color: #fff;\n    }\n\n    td.mat-mdc-cell,\n    th.mat-mdc-header-cell {\n      padding: 0 12px;\n    }\n\n    .selected-row {\n      td.mat-mdc-cell {\n        background-color: var(--p-primary-100, #e3f2fd);\n        font-weight: 500;\n      }\n    }\n\n    tr.mat-mdc-row:hover {\n      background-color: var(--p-surface-100, #f5f5f5);\n    }\n\n    tr.mat-mdc-row.selected-row:hover td.mat-mdc-cell {\n      background-color: var(--p-primary-100, #e3f2fd);\n    }\n  }\n\n  .empty-message {\n    color: var(--p-text-muted-color, #888);\n    padding: 16px 0;\n  }\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
